 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"pages-actDetails~pages-apply~pages-articleDetails~pages-asset~pages-asset_add~pages-asset_list~pages~a81cca64":"pages-actDetails~pages-apply~pages-articleDetails~pages-asset~pages-asset_add~pages-asset_list~pages~a81cca64","pages-actDetails~pages-apply~pages-articleDetails~pages-asset~pages-asset_add~pages-asset_list~pages~6b8b4c37":"pages-actDetails~pages-apply~pages-articleDetails~pages-asset~pages-asset_add~pages-asset_list~pages~6b8b4c37","pages-actDetails":"pages-actDetails","pages-apply":"pages-apply","pages-articleDetails":"pages-articleDetails","pages-asset":"pages-asset","pages-asset_add":"pages-asset_add","pages-asset_list~pages-pay_detail~pages-pay_list":"pages-asset_list~pages-pay_detail~pages-pay_list","pages-asset_list":"pages-asset_list","pages-pay_detail":"pages-pay_detail","pages-pay_list":"pages-pay_list","pages-blockchainquery":"pages-blockchainquery","pages-companyProflie":"pages-companyProflie","pages-copyright":"pages-copyright","pages-development~pages-forget~pages-login~pages-publish~pages-register":"pages-development~pages-forget~pages-login~pages-publish~pages-register","pages-development":"pages-development","pages-publish":"pages-publish","pages-digital_assets":"pages-digital_assets","pages-digital_assets_add":"pages-digital_assets_add","pages-expert":"pages-expert","pages-expo":"pages-expo","pages-game":"pages-game","pages-gameDtail":"pages-gameDtail","pages-index":"pages-index","pages-invest":"pages-invest","pages-member":"pages-member","pages-news":"pages-news","pages-notice_details":"pages-notice_details","pages-notice_list":"pages-notice_list","pages-oversea":"pages-oversea","pages-subsidy":"pages-subsidy","pages-versionNumber":"pages-versionNumber","pages-forget~pages-login~pages-register":"pages-forget~pages-login~pages-register","pages-forget":"pages-forget","pages-login":"pages-login","pages-register":"pages-register"}[chunkId]||chunkId) + "." + {"pages-actDetails~pages-apply~pages-articleDetails~pages-asset~pages-asset_add~pages-asset_list~pages~a81cca64":"0ca79fa6","pages-actDetails~pages-apply~pages-articleDetails~pages-asset~pages-asset_add~pages-asset_list~pages~6b8b4c37":"cc125a55","pages-actDetails":"88a017ce","pages-apply":"1c5bf76d","pages-articleDetails":"58f9726c","pages-asset":"5b657900","pages-asset_add":"c03464e1","pages-asset_list~pages-pay_detail~pages-pay_list":"cba3b17b","pages-asset_list":"131d402f","pages-pay_detail":"fad3357d","pages-pay_list":"a4435170","pages-blockchainquery":"ea0a822e","pages-companyProflie":"c08c1d8b","pages-copyright":"f3e6822e","pages-development~pages-forget~pages-login~pages-publish~pages-register":"47804a80","pages-development":"4516849e","pages-publish":"5ca3da2b","pages-digital_assets":"a858391d","pages-digital_assets_add":"5c092cbb","pages-expert":"e76984d6","pages-expo":"51edd839","pages-game":"5dc21313","pages-gameDtail":"2c4bc7df","pages-index":"4509404e","pages-invest":"9ca64efc","pages-member":"708eba9c","pages-news":"c862cdfb","pages-notice_details":"489c768c","pages-notice_list":"32098f0d","pages-oversea":"2720c30f","pages-subsidy":"b1d842ce","pages-versionNumber":"b4c1d567","pages-forget~pages-login~pages-register":"d6ee4e71","pages-forget":"bc04cf9c","pages-login":"e30dd6a3","pages-register":"872675a9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
